<template>
  <section class="psi-skeleton-container">
    <div class="psi-skeleton-container-top">
      <div class="psi-skeleton-container-top-header">
        <Skeleton height="20px" width="150px" borderRadius="4px" />
        <Skeleton height="18px" width="216px" borderRadius="4px" />
      </div>
      <div class="psi-skeleton-container-top-main">
        <div class="psi-skeleton-container-top-main-left">
          <div class="psi-skeleton-container-top-main-left-top">
            <div class="psi-skeleton-container-top-main-left-top-header">
              <Skeleton height="18px" width="170px" borderRadius="4px" />
              <Skeleton height="18px" width="63px" borderRadius="4px" />
            </div>
            <div class="psi-skeleton-container-top-main-left-top-row">
              <Skeleton height="14px" width="469px" borderRadius="4px" />
            </div>
          </div>
          <div class="psi-skeleton-container-top-main-left-content">
            <Skeleton
              v-for="i in 4"
              :key="i"
              :svgSrc="PdpCartSvg"
              height="64px"
              width="64px"
              borderRadius="8px"
            />
          </div>
        </div>
        <div class="psi-skeleton-container-top-main-divider"></div>
        <div class="psi-skeleton-container-top-main-right">
          <div class="psi-skeleton-container-top-main-right-top">
            <div class="psi-skeleton-container-top-main-right-top-header">
              <Skeleton height="18px" width="170px" borderRadius="4px" />
              <Skeleton height="18px" width="63px" borderRadius="4px" />
            </div>
            <div class="psi-skeleton-container-top-main-right-top-row">
              <Skeleton height="28px" width="445px" borderRadius="4px" />
            </div>
          </div>
          <div class="psi-skeleton-container-top-main-right-content">
            <Skeleton
              :svgSrc="PdpCartSvg"
              height="64px"
              width="64px"
              borderRadius="8px"
            />
          </div>
        </div>
      </div>
      <div class="psi-skeleton-container-top-footer">
        <div class="psi-skeleton-container-top-footer-left">
          <Skeleton width="20px" height="20px" borderRadius="4px" />
          <Skeleton width="206px" height="16px" borderRadius="4px" />
        </div>
        <div class="psi-skeleton-container-top-footer-right">
          <Skeleton width="212px" height="40px" borderRadius="6px" />
        </div>
      </div>
    </div>

    <div class="psi-skeleton-container-middle">
      <div class="psi-skeleton-container-middle-main">
        <div class="psi-skeleton-container-middle-main-left">
          <div class="psi-skeleton-container-middle-main-left-top">
            <Skeleton width="170px" height="18px" borderRadius="4px" />
            <Skeleton width="469px" height="14px" borderRadius="4px" />
            <Skeleton width="400px" height="14px" borderRadius="4px" />
          </div>
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="469px" height="80px" borderRadius="4px" />
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="180px" height="20px" borderRadius="4px" />
        </div>
        <div class="psi-skeleton-container-middle-main-divider"></div>
        <div class="psi-skeleton-container-middle-main-right">
          <div class="psi-skeleton-container-middle-main-right-top">
            <Skeleton width="170px" height="18px" borderRadius="4px" />
            <Skeleton width="469px" height="14px" borderRadius="4px" />
            <Skeleton width="400px" height="14px" borderRadius="4px" />
          </div>
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="469px" height="80px" borderRadius="4px" />
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="469px" height="40px" borderRadius="4px" />
          <Skeleton width="180px" height="20px" borderRadius="4px" />
        </div>
      </div>
      <div class="psi-skeleton-container-middle-footer">
        <div class="psi-skeleton-container-middle-footer-left">
          <Skeleton width="20px" height="20px" borderRadius="4px" />
          <Skeleton width="206px" height="16px" borderRadius="4px" />
        </div>
        <div class="psi-skeleton-container-middle-footer-right">
          <Skeleton width="212px" height="40px" borderRadius="6px" />
        </div>
      </div>
    </div>

    <div class="psi-skeleton-container-bottom">
      <div class="psi-skeleton-container-bottom-header">
        <Skeleton width="170px" height="18px" borderRadius="4px" />
        <Skeleton fullWidth height="14px" borderRadius="4px" />
        <Skeleton width="300px" height="14px" borderRadius="4px" />
      </div>
      <div class="psi-skeleton-container-bottom-content">
        <div class="psi-skeleton-container-bottom-content-left">
          <Skeleton fullWidth height="80px" borderRadius="4px" />
          <Skeleton fullWidth height="80px" borderRadius="4px" />
          <Skeleton fullWidth height="80px" borderRadius="4px" />
          <Skeleton fullWidth height="80px" borderRadius="4px" />
          <Skeleton fullWidth height="40px" borderRadius="4px" />
        </div>
        <div class="psi-skeleton-container-bottom-content-right">
          <Skeleton fullWidth height="80px" borderRadius="4px" />
          <Skeleton fullWidth height="80px" borderRadius="4px" />
          <Skeleton fullWidth height="80px" borderRadius="4px" />
          <Skeleton fullWidth height="80px" borderRadius="4px" />
        </div>
      </div>
      <div class="psi-skeleton-container-bottom-footer">
        <div class="psi-skeleton-container-bottom-footer-left">
          <Skeleton width="20px" height="20px" borderRadius="4px" />
          <Skeleton width="206px" height="16px" borderRadius="4px" />
        </div>
        <div class="psi-skeleton-container-bottom-footer-right">
          <Skeleton width="212px" height="40px" borderRadius="6px" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import Skeleton from '@/components/Skeleton/Skeleton';
import PdpCartSvg from '@/assets/images/skeleton/pdp-cart.svg';
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

%sk-flex-column-start {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

%sk-section {
  @extend %sk-flex-column-start;
  align-self: stretch;
}

%sk-column {
  @extend %sk-flex-column-start;
  gap: 16px;
  flex: 1 0 0;
}

%sk-row {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}

%sk-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  align-self: stretch;
}

%sk-footer-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

%sk-footer-right {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
}

%sk-block-top {
  @extend %sk-flex-column-start;
  gap: 8px;
  align-self: stretch;
}

.psi-skeleton-container {
  @extend %sk-flex-column-start;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid $colorD20;
  background: $colorN00;

  &-top {
    @extend %sk-section;
    padding-bottom: 24px;
    border-bottom: 1px solid $colorD20;

    &-header {
      display: flex;
      padding: 24px 24px 16px 24px;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      border-bottom: 0.5px solid $colorD20;
    }

    &-main {
      @extend %sk-row;
      padding: 16px 24px;

      &-left {
        @extend %sk-column;

        &-top {
          @extend %sk-block-top;
          height: 40px;

          &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-self: stretch;
          }
        }

        &-content {
          display: flex;
          width: auto;
          height: 104px;
          align-items: flex-start;
          gap: 12px;
        }
      }

      &-right {
        @extend %sk-column;
        padding-right: 24px;

        &-top {
          @extend %sk-block-top;

          &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            align-self: stretch;
          }

          &-content {
            display: flex;
            width: auto;
            height: 104px;
            align-items: flex-start;
            gap: 12px;
          }
        }
      }

      &-divider {
        width: 0.5px;
        height: 160px;
        background: $colorD20;
        align-self: center;
      }
    }

    &-footer {
      @extend %sk-footer;
      padding-right: 24px;

      &-left {
        @extend %sk-footer-left;
      }

      &-right {
        @extend %sk-footer-right;
      }
    }
  }

  &-middle {
    @extend %sk-section;
    padding: 24px;
    gap: 16px;

    &-main {
      @extend %sk-row;

      &-left {
        @extend %sk-column;

        &-top {
          @extend %sk-block-top;
          height: 68px;
        }
      }

      &-right {
        @extend %sk-column;

        &-top {
          @extend %sk-block-top;
          height: 68px;
        }
      }

      &-divider {
        width: 0.5px;
        height: 424px;
        background: $colorD20;
      }
    }

    &-footer {
      @extend %sk-footer;

      &-left {
        @extend %sk-footer-left;
      }

      &-right {
        @extend %sk-footer-right;
      }
    }
  }

  &-bottom {
    @extend %sk-section;
    width: 100%;
    padding: 24px;
    gap: 16px;
    border-radius: 0 0 8px 8px;
    border: 1px solid $colorD20;
    background: $colorN00;

    &-header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;
      align-self: stretch;
    }

    &-content {
      @extend %sk-row;

      &-left {
        @extend %sk-column;
      }

      &-right {
        @extend %sk-column;
      }
    }

    &-footer {
      @extend %sk-footer;

      &-left {
        @extend %sk-footer-left;
      }

      &-right {
        @extend %sk-footer-right;
      }
    }
  }
}
</style>
